import './css/get-started.css';
import P2PI from './P2PI';
import P2PII from './P2PII';
import P2PIII from './P2PIII';
import P2PIV from './P2PIV';
import Start from './Start';
import Mobile from './Mobile';

export default function GetStarted() {

  return (
    <section id="getStarted">
      <div id="start">
        <Start />
      </div>
      <div className="whyChooseUs">
        <h2>Why choose <span className="logoNameII">i<span style={{color: 'rgb(59, 194, 149)'}}>Dey</span>Pay?</span></h2>
        <div className="chooseUs-items">
          <P2PI />
          <P2PII />
          <P2PIII />
          <P2PIV />
        </div>
      </div>
      <div className="mobile-wrapper">
        <Mobile />
      </div>
    </section>
  )
}
